/**
 * Help Search - Search input for the Help Center
 */

import React, { useRef, useEffect } from 'react';
import { Search, X } from 'lucide-react';

export interface HelpSearchProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  autoFocus?: boolean;
}

export function HelpSearch({ 
  value, 
  onChange, 
  onClear,
  placeholder = 'Search help articles...',
  autoFocus = true
}: HelpSearchProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Search className="h-5 w-5 text-slate-400" />
      </div>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
          w-full pl-10 pr-10 py-2.5
          bg-slate-100 dark:bg-slate-700
          border border-transparent
          focus:border-blue-500 focus:bg-white dark:focus:bg-slate-800
          rounded-lg
          text-slate-900 dark:text-white
          placeholder-slate-500 dark:placeholder-slate-400
          focus:outline-none focus:ring-2 focus:ring-blue-500/20
          transition-all duration-200
        "
      />
      {value && (
        <button
          onClick={onClear}
          className="
            absolute inset-y-0 right-0 pr-3 
            flex items-center 
            text-slate-400 hover:text-slate-600 dark:hover:text-slate-300
            transition-colors
          "
          aria-label="Clear search"
        >
          <X className="h-5 w-5" />
        </button>
      )}
    </div>
  );
}





